import { render, staticRenderFns } from "./ProfileCreateModalVkplay.vue?vue&type=template&id=c1debe3a"
import script from "./ProfileCreateModalVkplay.vue?vue&type=script&lang=js"
export * from "./ProfileCreateModalVkplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports